import { useEffect } from 'react';

import type { JsonLdDocument } from 'src/types/json-ld';

export function useJsonLd(...documents: JsonLdDocument[]) {
  const serialized = JSON.stringify(documents);

  useEffect(() => {
    const parsed: JsonLdDocument[] = JSON.parse(serialized);

    const scripts = parsed.map((document_) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(document_);
      document.head.appendChild(script);
      return script;
    });

    return () => {
      scripts.forEach((script) => {
        script.remove();
      });
    };
  }, [serialized]);
}
